import { render } from "./LogManagement.vue?vue&type=template&id=2d988d9c"
import script from "./LogManagement.vue?vue&type=script&lang=js"
export * from "./LogManagement.vue?vue&type=script&lang=js"

import "./LogManagement.vue?vue&type=style&index=0&id=2d988d9c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__